"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/builtin/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _CssBaseline.default;
  }
});

var _CssBaseline = _interopRequireDefault(require("./CssBaseline"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/CssBaseline/index.js
 ** module id = 831
 ** module chunks = 0
 **/